import { Options } from '../Options'
import type { ColorPatternName } from './Colors.types'

export type ChartColorPalette =
  | 'default'
  | 'neutral'
  | 'brand'
  | 'categorical'
  | 'sequential'

export const CMS_COLOR_PALETTE_TO_PATTERN = {
  default: 'qualitative.default',
  neutral: 'qualitative.neutral',
  brand: 'qualitative.brand',
  categorical: 'qualitative.default',
  sequential: 'sequential.default',
} as const satisfies Record<ChartColorPalette, ColorPatternName>

export const colorPaletteOptions = Options.asRecord(
  Options.createOption({
    key: 'colorPalette',
    inputKind: 'select',
    selectChoices: [
      { value: 'default', label: 'Default' },
      { value: 'neutral', label: 'Neutral' },
      { value: 'brand', label: 'Brand' },
      { value: 'categorical', label: 'Categorical' },
      { value: 'sequential', label: 'Sequential' },
    ],
    defaultValue: 'default',
    label: 'Color palette',
    description: 'Qualitative palette used to color series.',
    category: 'Color',
  }),
)

export const colorOverrideOptions = Options.asRecord(
  Options.createOption({
    key: 'color',
    inputKind: 'color',
    label: 'Color',
    description: 'Per-series color override.',
    category: 'Color',
  }),
  Options.createOption({
    key: 'fillColor',
    inputKind: 'color',
    label: 'Fill color',
    description: 'Per-series fill color override.',
    category: 'Color',
  }),
  Options.createOption({
    key: 'highlightColor',
    inputKind: 'color',
    label: 'Highlight color',
    description: 'Per-series highlight color override.',
    category: 'Color',
  }),
)

export const colorOptions = {
  ...colorPaletteOptions,
  ...colorOverrideOptions,
}
